import dexieDB from "database/dexieDB";
import { GET_ALL_DAFFI_USERS, GET_ALL_LOCAL_USERS, REFRESH_APP_DATA } from "helpers/constants";
import { getAllAccountsByUser } from "actions/accounts";

export const getAllExistingUsers = () => async (dispatch) => {
	const localUsers = await dexieDB.localUsers.toArray().then((localUsers) => {
		return localUsers.map((user) => user.data);
	});

	const daffiUsers = await dexieDB.daffiUsers.toArray().then((daffiUsers) => {
		return daffiUsers.map((user) => user.data);
	});

	dispatch({ type: GET_ALL_LOCAL_USERS, payload: localUsers?.length ? localUsers : null });
	dispatch({ type: GET_ALL_DAFFI_USERS, payload: daffiUsers?.length ? daffiUsers : null });
};

export const refreshAppData = (count) => async (dispatch) => {
	dispatch(getAllAccountsByUser());

	dispatch({ type: REFRESH_APP_DATA, payload: count });
};
